var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.544 9.602c0.889-0.782 1.453-1.924 1.453-3.198 0-2.352-1.913-4.265-4.265-4.265-1.605 0-3.004 0.892-3.732 2.205-0.728-1.313-2.127-2.205-3.732-2.205-2.352 0-4.265 1.913-4.265 4.265 0 1.274 0.564 2.416 1.453 3.198h-6.251v20.259h25.59v-20.259h-6.251zM27.729 10.668v8.53h-11.196v-8.53h0.681l2.588 4.53 0.926-0.529-2.286-4.001h9.287zM16 8.544l0.604 1.058h-1.209l0.604-1.058zM19.732 3.205c1.764 0 3.199 1.435 3.199 3.199s-1.435 3.198-3.199 3.198c-1.764 0-3.199-1.434-3.199-3.198s1.435-3.199 3.199-3.199zM9.069 6.404c0-1.764 1.435-3.199 3.199-3.199s3.199 1.435 3.199 3.199c0 1.763-1.435 3.198-3.199 3.198s-3.199-1.434-3.199-3.198zM13.558 10.668l-2.286 4 0.926 0.529 2.588-4.53h0.681v8.53h-11.196v-8.53h9.287zM4.271 20.265h11.196v8.53h-11.196v-8.53zM16.533 28.794v-8.53h11.196v8.53h-11.196z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.74b5f0a85372694e4c704c4634fb7b45.svg";
export { ForwardRef as ReactComponent };